// internal
import { axios, def, handleError, handleResponse } from './internal';

// state
import { storage } from '@goldblack/client-storage';

function AdminUserChangeVerified(userId, verified, onSuccess) {
    axios
        .post('/api/admin_user_changeverified', {
            userId,
            verified,
        })
        .then((res) => {
            switch (res.data.code) {
                case def.ErrorCode.OK:
                    const { user } = res.data.data;

                    let callback = (x) => x._id === userId;
                    storage.transience.updateState('search.result', callback, user);

                    storage.transience.setState('internal.success', 'The verification status has been updated.');
                    if (onSuccess) onSuccess(user);
                    break;
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => {
            handleError(err);
        });
}

export { AdminUserChangeVerified };
